<div class="holdings-container">
  <div class="holdings-view-toggle">
    <mat-button-toggle-group [(value)]="holdingsViewMode" hideSingleSelectionIndicator>
      <mat-button-toggle value="year">By Year</mat-button-toggle>
      <mat-button-toggle value="company">By Company</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  @if (holdingsViewMode === 'year') {
    @if (holdingsByYear.length === 0) {
      <div class="empty-state">No holdings available</div>
    }
    @for (group of holdingsByYear; track group.year) {
      <section class="section-container nrg-border-radius">
        <div class="section-header">Year: {{ group.year }}</div>
        <div class="section-content">
          <div class="holdings-list">
            <table mat-table [dataSource]="group.holdings" class="mat-elevation-z2 holdings-table">
              <ng-container matColumnDef="companyName">
                <th mat-header-cell *matHeaderCellDef>Company</th>
                <td mat-cell *matCellDef="let h">
                  <span class="name-cell">
                    <a [routerLink]="['/companies/edit', h.companyId]" [queryParams]="{tab: 'ownership', year: group.year}" class="company-link-btn" title="Go to ownership tab" (click)="$event.stopPropagation()">
                      <mat-icon>open_in_new</mat-icon>
                    </a>
                    {{ h.companyName }}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="firstClassSharesPercentage">
                <th mat-header-cell *matHeaderCellDef>1st Class %</th>
                <td mat-cell *matCellDef="let h">{{ formatPercentage(h.firstClassSharesPercentage) }}</td>
              </ng-container>
              <ng-container matColumnDef="firstClassShares">
                <th mat-header-cell *matHeaderCellDef>1st Class Shares</th>
                <td mat-cell *matCellDef="let h">{{ formatNumber(h.firstClassShares) }}</td>
              </ng-container>
              <ng-container matColumnDef="secondClassSharesPercentage">
                <th mat-header-cell *matHeaderCellDef>2nd Class %</th>
                <td mat-cell *matCellDef="let h">{{ formatPercentage(h.secondClassSharesPercentage) }}</td>
              </ng-container>
              <ng-container matColumnDef="secondClassShares">
                <th mat-header-cell *matHeaderCellDef>2nd Class Shares</th>
                <td mat-cell *matCellDef="let h">{{ formatNumber(h.secondClassShares) }}</td>
              </ng-container>
              <ng-container matColumnDef="thirdClassSharesPercentage">
                <th mat-header-cell *matHeaderCellDef>3rd Class %</th>
                <td mat-cell *matCellDef="let h">{{ formatPercentage(h.thirdClassSharesPercentage) }}</td>
              </ng-container>
              <ng-container matColumnDef="thirdClassShares">
                <th mat-header-cell *matHeaderCellDef>3rd Class Shares</th>
                <td mat-cell *matCellDef="let h">{{ formatNumber(h.thirdClassShares) }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="holdingsByYearDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: holdingsByYearDisplayedColumns;"></tr>
            </table>
          </div>
        </div>
      </section>
    }
  }

  @if (holdingsViewMode === 'company') {
    @if (holdingsByCompany.length === 0) {
      <div class="empty-state">No holdings available</div>
    }
    @for (group of holdingsByCompany; track group.companyId) {
      <section class="section-container nrg-border-radius">
        <div class="section-header">
          <span class="name-cell">
            <a [routerLink]="['/companies/edit', group.companyId]" class="company-link-btn" title="Edit company" (click)="$event.stopPropagation()">
              <mat-icon>open_in_new</mat-icon>
            </a>
            {{ group.companyName }}
          </span>
        </div>
        <div class="section-content">
          <div class="holdings-list">
            <table mat-table [dataSource]="group.holdings" class="mat-elevation-z2 holdings-table">
              <ng-container matColumnDef="year">
                <th mat-header-cell *matHeaderCellDef>Year</th>
                <td mat-cell *matCellDef="let h">
                  <a [routerLink]="['/companies/edit', group.companyId]" [queryParams]="{tab: 'ownership', year: h.year}" class="company-link-btn" title="Go to ownership tab" (click)="$event.stopPropagation()">
                    {{ h.year }}
                  </a>
                </td>
              </ng-container>
              <ng-container matColumnDef="firstClassSharesPercentage">
                <th mat-header-cell *matHeaderCellDef>1st Class %</th>
                <td mat-cell *matCellDef="let h">{{ formatPercentage(h.firstClassSharesPercentage) }}</td>
              </ng-container>
              <ng-container matColumnDef="firstClassShares">
                <th mat-header-cell *matHeaderCellDef>1st Class Shares</th>
                <td mat-cell *matCellDef="let h">{{ formatNumber(h.firstClassShares) }}</td>
              </ng-container>
              <ng-container matColumnDef="secondClassSharesPercentage">
                <th mat-header-cell *matHeaderCellDef>2nd Class %</th>
                <td mat-cell *matCellDef="let h">{{ formatPercentage(h.secondClassSharesPercentage) }}</td>
              </ng-container>
              <ng-container matColumnDef="secondClassShares">
                <th mat-header-cell *matHeaderCellDef>2nd Class Shares</th>
                <td mat-cell *matCellDef="let h">{{ formatNumber(h.secondClassShares) }}</td>
              </ng-container>
              <ng-container matColumnDef="thirdClassSharesPercentage">
                <th mat-header-cell *matHeaderCellDef>3rd Class %</th>
                <td mat-cell *matCellDef="let h">{{ formatPercentage(h.thirdClassSharesPercentage) }}</td>
              </ng-container>
              <ng-container matColumnDef="thirdClassShares">
                <th mat-header-cell *matHeaderCellDef>3rd Class Shares</th>
                <td mat-cell *matCellDef="let h">{{ formatNumber(h.thirdClassShares) }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="holdingsByCompanyDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: holdingsByCompanyDisplayedColumns;"></tr>
            </table>
          </div>
        </div>
      </section>
    }
  }
</div>
